import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { changeDateFormat } from '@utils/Util';

const CollectionCard = ({ details }) => {
	const navigate = useNavigate();
	const onRedirectToPage = () => {
		if (details?.collectionApprovalStatus === 'APPROVED')
			return navigate(`/collections/view/${details.collectionId}`);
		return navigate(`/collection/request/${details.id}`);
	};

	let docs = details?.productImageList?.length > 0 ? details?.productImageList : details.moodboardImageList;

	const renderDefaultThreeImages = () => {
		return (
			<div className="product-img-container" onClick={onRedirectToPage}>
				<div className="prev-img">
					{docs.length > 0 ? (
						<img src={docs[0]?.docUrl} alt="" />
					) : (
						<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
					)}
				</div>
				<div className="prev-img-thumb">
					{docs.length > 1 ? (
						<div className="single-first">
							<img src={docs[1]?.docUrl} alt="" />
						</div>
					) : (
						<div className="single-first">
							<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
						</div>
					)}
					{docs.length > 2 ? (
						<div className="single-second">
							<img src={docs[2]?.docUrl} alt="" />
						</div>
					) : (
						<div className="single-second">
							<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
						</div>
					)}
				</div>
			</div>
		);
	};

	const renderSingleImage = () => {
		return (
			<Fragment>
				<img src={docs[0]?.docUrl} alt="" className="w-100" />
			</Fragment>
		);
	};

	const renderMultiImages = () => {
		return (
			<Fragment>
				{docs.length ? (
					<img src={docs[0]?.docUrl} alt="" className="w-100" />
				) : (
					<img
						src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
						alt=""
						className="w-100"
					/>
				)}

				{docs.length > 1 ? (
					<img src={docs[1]?.docUrl} alt="" className="w-100" />
				) : (
					<img
						src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
						alt=""
						className="w-100"
					/>
				)}
				{docs.length > 2 ? (
					<img src={docs[2]?.docUrl} alt="" className="w-100" />
				) : (
					<img
						src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
						alt=""
						className="w-100"
					/>
				)}
				{docs.length > 3 ? (
					<img src={docs[3]?.docUrl} alt="" className="w-100" />
				) : (
					<img
						src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
						alt=""
						className="w-100"
					/>
				)}
				{docs.length > 4 ? (
					<img src={docs[4]?.docUrl} alt="" className="w-100" />
				) : (
					<img
						src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
						alt=""
						className="w-100"
					/>
				)}
				{docs.length > 5 ? (
					<img src={docs[5]?.docUrl} alt="" className="w-100" />
				) : (
					<img
						src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
						alt=""
						className="w-100"
					/>
				)}
			</Fragment>
		);
	};

	const renderMoodBoardLayout = (imageType) => (
		<div
			className={`${
				imageType === 'MOODBOARD_IAMGE' ? 'masonry-images full-moodboard-photo' : 'masonry-images'
			}`}
			onClick={onRedirectToPage}
		>
			{imageType === 'MOODBOARD_IAMGE' ? renderSingleImage() : renderMultiImages()}
		</div>
	);

	const renderCollectionList = (collection) => {
		if (collection?.productImageList?.length > 0) {
			return collection?.productImageList?.length > 3
				? renderMoodBoardLayout('PRODUCT_IAMGE', collection)
				: renderDefaultThreeImages(collection);
		} else if (collection?.moodboardImageList?.length > 0) {
			return renderMoodBoardLayout('MOODBOARD_IAMGE', collection);
		} else {
			return renderDefaultThreeImages(collection);
		}
	};

	return (
		<div className="sample-single-item cursor-pointer" onClick={() => onRedirectToPage()}>
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-10 col-xl-8 pl-0">
						<div className="collection-info-details d-flex">
							{renderCollectionList(details)}
							<div className="contents pl-3">
								<p className="medium-16 gray_dark_01 mb-1">
									{details?.title || details?.name}
								</p>
								<span className="brand-common-design mb-1">
									{details?.brandResponse?.name}
								</span>
								<span className="regular-14 gray_dark_01 ml-4 mb-1">
									<span className="gray_dark_02">Required</span>
									<span className="gray_dark_01 ml-2">
										{changeDateFormat(details?.requestedAt, '', 'Do MMM')}
									</span>
								</span>
								<p className="semibold-12 pt-3">Description</p>
								<p className="regular-12 gray_dark_01 mt-1">{details?.description}</p>
							</div>
						</div>
					</div>
					<div className="col-md-2 col-xl-4">
						<div className="sample-status">
							<span className="status">Collection request</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CollectionCard;
